import { apiClient } from './apiClient';

export const getKPIList = () => {
    return apiClient.get('/zoho/kpi');
};
